import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input'

export default () => {
    const [value, setValue] = useState()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')

  return (
    <div className=' payment-inner-box'>
        <div className="contact-sub-head mb-4">
                            <h4>Billing Adress</h4>
                        </div>
        <div className='row'>
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
          <label>First Name</label>
          <input
            className='u-full-width'
            placeholder='First Name'
            type='text'
            onChange={e => setFirstName(e.target.value)}
            value={firstName}
            autoFocus
          />
        </div>
      </div>
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
          <label>Last Name</label>
          <input
            className='u-full-width'
            placeholder='Last Name'
            type='text'
            onChange={e => setLastName(e.target.value)}
            value={lastName}
          />
        </div>
      </div>
      <div className='col-lg-12 mb-4'>
        <div className='six columns'>
          <label>Email</label>
          <input
            className='u-full-width'
            placeholder='Email'
            type='email'
            onChange={e => setEmail(e.target.value)}
            value={email}
            autoFocus
          />
        </div>
      </div>
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
        <label>State/Province</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Select State/Province</option>
                                <option value="India">India</option>
                                <option value="Australia">Australia</option>
                                <option value="Usa">USA</option>
                              </select>
        </div>
      </div>
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
        <label>City</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Select City</option>
                                <option value="India">India</option>
                                <option value="Australia">Australia</option>
                                <option value="Usa">USA</option>
                              </select>
        </div>
      </div>
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
        <label>Zip/ Postal Code</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Select Zip Code</option>
                                <option value="India">India</option>
                                <option value="Australia">Australia</option>
                                <option value="Usa">USA</option>
                              </select>
        </div>
      </div>
     
      <div className='col-lg-6 mb-4'>
        <div className='six columns'>
          <label>Phone Number</label>
                  <PhoneInput

                                                        value={value}
                                                        onChange={setValue} />
        </div>
      </div>
      </div>
    </div>
  )
}